import { render } from "./PageHeader.vue?vue&type=template&id=6f6ab3f3"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=6f6ab3f3&lang=css"

import exportComponent from "C:\\Programowanie\\Projects\\last38minutes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__